import { api, responseErrorCheck } from './api'

export const NFC_AUTH_API_BASE_URL = 'api/v1/urely'

export interface NfcAuthChallengeResponse {
  data?: {
    connectionId?: string
    APDU?: string
  }
}

export interface VerifyTapResponseData {
  uid?: string
}

export interface VerifyTapResponse {
  verificationStatus: 'OK' | 'KO'
  verificationCode: string
  verificationData: VerifyTapResponseData
}

export class NfcAuth {
  static resolveApiBaseUrl(apiBaseUrl?: string): string {
    return apiBaseUrl || NFC_AUTH_API_BASE_URL
  }

  static challenge(apdu: string, challenge: string, apiBaseUrl?: string) {
    const baseUrl = this.resolveApiBaseUrl(apiBaseUrl)
    return api
      .get<NfcAuthChallengeResponse>(`${baseUrl}/mutualAuth/challenge`, {
        apduRequest: apdu,
        challengeCode: challenge
      })
      .then((res) => responseErrorCheck(res))
  }

  static validate(apdu: string, connectionId: string, apiBaseUrl?: string) {
    const baseUrl = this.resolveApiBaseUrl(apiBaseUrl)
    return api
      .get<unknown>(`${baseUrl}/mutualAuth/validate`, { apduRequest: apdu, connectionId })
      .then((res) => responseErrorCheck(res))
  }

  static verifyTap(body: Record<string, string | number>, apiBaseUrl?: string) {
    const baseUrl = this.resolveApiBaseUrl(apiBaseUrl)
    return api.get<VerifyTapResponse>(`${baseUrl}/verifyTap`, body).then((res) => responseErrorCheck(res))
  }

  static retrieveData(uid: string, apiBaseUrl?: string) {
    const baseUrl = this.resolveApiBaseUrl(apiBaseUrl)
    return api.get<unknown>(`${baseUrl}/retrieveData`, { uid }).then((res) => responseErrorCheck(res))
  }
}
